import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import { Opinion } from "@/lib/types/Opinion";
import { useHomePageContext } from "@/src/features/home/HomePageContext";
import { useAppContext } from "@/src/config/AppProvider";

const OpinionsSection = () => {
  const { t } = useTranslation();
  const { getLocalization } = useAppContext();

  return (
    <div className="rbt-testimonial-area rbt-section-gap overflow-hidden">
      <div className="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <span className="subtitle bg-primary-opacity">{t("parentOpinions")}</span>
                <h2 className="title">{getLocalization("parentOpinionSlogan")}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Opinions />
    </div>
  );
};

const Opinions = (): ReactNode => {
  const { opinions } = useHomePageContext();

  let firstHalf: Opinion[];
  let secondHalf: Opinion[] = [];

  if (opinions.length >= 10) {
    firstHalf = opinions.slice(0, Math.ceil(opinions.length / 2));
    secondHalf = opinions.slice(Math.ceil(opinions.length / 2), opinions.length);
  } else {
    firstHalf = opinions;
  }

  return (
    <>
      {firstHalf.length > 0 && (
        <div className="scroll-animation-wrapper mt--50">
          <div className="scroll-animation scroll-right-left">
            {firstHalf.map(item => (
              <div className="single-column-20" key={item.IdGuid}>
                <div className="rbt-testimonial-box">
                  <div
                    className="inner"
                    style={{
                      padding: "32px"
                    }}
                  >
                    <div className="clint-info-wrapper">
                      <div>
                        <h5 className="title">{item.ParentDisplayName}</h5>
                      </div>
                    </div>
                    <div className="description">
                      <p className="subtitle-3 text-multiline-ellipsis-4">{item.Comment}</p>
                      <div className="rating mt--5">
                        {Array.from({ length: item.Rating }).map((_, index) => (
                          <i key={index} className="fas fa-star"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {secondHalf.length > 0 && (
        <div className="scroll-animation-wrapper mt--30">
          <div className="scroll-animation scroll-left-right">
            {secondHalf.map(item => (
              <div className="single-column-20" key={item.IdGuid}>
                <div className="rbt-testimonial-box">
                  <div
                    className="inner"
                    style={{
                      padding: "32px"
                    }}
                  >
                    <div className="clint-info-wrapper">
                      <div>
                        <h5 className="title">{item.ParentDisplayName}</h5>
                      </div>
                    </div>
                    <div className="description">
                      <p className="subtitle-3 text-multiline-ellipsis-4">{item.Comment}</p>
                      <div className="rating mt--5">
                        {Array.from({ length: item.Rating }).map((_, index) => (
                          <i key={index} className="fas fa-star"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default OpinionsSection;
